export default __webpack_public_path__ + "static/media/KaylaDeighan.d252c99e.jpg";